// frontend/src/pages/auth/authSuccess.tsx
import React, { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import styles from "./authSuccess.module.css";
const AuthSuccess = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const userParam = params.get("user");

    if (token && userParam) {
      try {
        const user = JSON.parse(decodeURIComponent(userParam));
        login(token, user);
        // Redirect to intended path or home
        const redirectPath = localStorage.getItem("preAuthPath");

        if (redirectPath) {
          navigate(redirectPath);
          setTimeout(() => {
            localStorage.removeItem("preAuthPath");
          }, 10000);
        } else {
          navigate("/");
        }
        // Use navigate instead of href
        // localStorage.removeItem("preAuthPath");
      } catch (error) {
        console.error("Auth processing error:", error);
        navigate("/");
      }
    } else {
      const redirectPath = localStorage.getItem("preAuthPath");
      if (redirectPath) {
        navigate(redirectPath);
        setTimeout(() => {
          localStorage.removeItem("preAuthPath");
        }, 10000);
      } else {
        navigate("/");
      }
    }
  }, [login, navigate]);

  return (
    <div>
      <div className={styles["preloader-plus"]}>
        <img
          src="/images/scadellogosvg.png"
          className={styles["preloader-custom-img"]}
          alt="scadelLogo"
        />
      </div>
    </div>
  );
};

export default AuthSuccess;
